import { combineReducers } from 'redux'
import PREVIEW from './previewTypes'

const isPagePreviewerOpened = (state = false, action) => {
  const { type } = action
  switch (type) {
    case PREVIEW.OPEN_PAGE_PREVIEWER:
      return true
    case PREVIEW.CLOSE_PREVIEWER:
      return false
    default:
      return state
  }
}

const isCanvasPreviewerOpened = (state = false, action) => {
  const { type } = action
  switch (type) {
    case PREVIEW.OPEN_CANVAS_PREVIEWER:
      return true
    case PREVIEW.CLOSE_PREVIEWER:
      return false
    default:
      return state
  }
}

const previewPageId = (state = null, action) => {
  const { type } = action
  switch (type) {
    case PREVIEW.OPEN_PAGE_PREVIEWER:
      return action.payload
    default:
      return state
  }
}

export default combineReducers({
  isPagePreviewerOpened,
  isCanvasPreviewerOpened,
  previewPageId,
})



// WEBPACK FOOTER //
// ./src/store/preview/previewReducer.js